import { createAnnotation } from "@routes/Article/components/ArticleParagraphElements/annotation/AnnotationFactory";
import { ArticleNonParagraphProps } from "@routes/Article/components/ArticleParagraphElements/utils/types";
import parse, { DOMNode, domToReact } from "html-react-parser";

/** Box title which use in box element */
const BoxTitle = ({
  bodyString,
}: ArticleNonParagraphProps): React.ReactElement => {
  const transformAnnotation = createAnnotation({});

  const transfromTitle = (
    node: DOMNode
  ): string | boolean | void | object | Element | null => {
    if (node.type === "tag" && node.name === "p") {
      const el = node;

      return (
        <>
          {domToReact([el], {
            replace: transformAnnotation,
          })}
        </>
      );
    }
  };

  return (
    <div className="font-bold" data-testid="article-box-title-component">
      {parse(bodyString, { replace: transfromTitle })}
    </div>
  );
};

export default BoxTitle;
